import { createBrowserHistory } from 'history';

export const historyInstance = createBrowserHistory();
